import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VendorDefinition } from '../../models/integration/vendor-definition.model';

/**
 * Info modal shown on the ORG SETTINGS for a per-company vendor (e.g. Bexio).
 *
 * That vendor's connection lives per company, not at org level, so this modal is
 * purely informational: it tells the admin the integration is managed in the
 * individual company's profile. Single OK button, no routing.
 *
 * (The per-org → Org-Settings case is handled by `IntegrationGoToAdminModalComponent`.)
 */
@Component({
    selector: 'aumico-vendor-org-redirect-modal',
    templateUrl: './vendor-org-redirect-modal.component.html',
    styleUrls: ['./vendor-org-redirect-modal.component.scss'],
})
export class VendorOrgRedirectModalComponent {
    @Input() public vendor!: VendorDefinition;

    @Output() public closed = new EventEmitter<void>();

    public onClose(): void {
        this.closed.emit();
    }
}
